import { actions } from 'react-redux-form';
import * as Api from "products/orderHdListings/api";
import * as OrderHdListingsForm from "products/orderHdListings/OrderHdListings";
import * as formHelpers from "common/utils/formHelpers";
export const submitRequest = (dto) => {
    return (dispatch) => {
        formHelpers.formAsynSubmit(dispatch, OrderHdListingsForm.pathsOrderHdListingsForm.modelPath, Api.async_sendRequest(dispatch, dto), (dispatch) => {
            //notifier.notifySuccess("Message Sent", "One of our consultants will be in contact with you shortly.");
        }, (dispatch) => dispatch(actions.setPending(OrderHdListingsForm.pathsOrderHdListingsForm.modelPath, false)), false);
    };
};
